import { useEffect } from "react";

import { useCustomer } from "~/hooks/useSession";
import { useKlaviyo } from "~/hooks/useKlaviyo";

/**
 * This component subscribes to application state (like authentication) to
 * update the various analytics trackers.
 */
export function AnalyticsSubscriber() {
  const klaviyo = useKlaviyo();
  const customer = useCustomer();

  useEffect(() => {
    if (!customer) return; // Not logged in.
    if (!customer.email && !customer.firstName && !customer.lastName) return; // Not enough info.

    // Identify the customer to Klaviyo.
    klaviyo.identify({
      ...(customer.email ? { $email: customer.email } : {}),
      ...(customer.firstName ? { $first_name: customer.firstName } : {}),
      ...(customer.lastName ? { $last_name: customer.lastName } : {}),
    });
  }, [klaviyo, customer]);

  return null;
}
